import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  didNotificationState: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
  postApiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const didNotificationSlice = createSlice({
  name: "didNotification",
  initialState: INITIAL_STATE,
  reducers: {
    fetchDidNotification: (state) => {
      state.didNotificationState.isLoading = true;
    },
    fetchDidNotificationSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      didNotificationState: {
        ...state.didNotificationState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchDidNotificationFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      didNotificationState: {
        ...state.didNotificationState,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),

    clearDidNotification: (state) => ({
      ...state,
      didNotificationState: {
        ...state.didNotificationState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: null,
      },
    }),
  },
});

export const {
  fetchDidNotification,
  fetchDidNotificationFailure,
  fetchDidNotificationSuccess,
  clearDidNotification,
} = didNotificationSlice.actions;
export const didNotificationReducer = didNotificationSlice.reducer;
